import { AlertOptions } from "react-native";
import Toast, { ToastShowParams } from "react-native-toast-message";

import { Alert } from "./Alert";
import { AlertParams, AlertProps } from "./Alert.type";
import { setStyles } from "./libs/setStyles";
import { defaultTheme } from "../../../structure/layout/theme/Theme.types";

export const useAlert = () => {
  const toastConfig = {
    basic: (toastProps: ToastShowParams) => Alert(toastProps.props),
  };
  const colors = defaultTheme.colors;

  const success = ({
    message,
    title,
    onPress,
    options,
    variant,
    headerClassNames,
    bodyClassNames,
    containerClassNames,
    align,
  }: AlertParams) => {
    return show(
      {
        message,
        ...setStyles(variant || "default", "success", headerClassNames, bodyClassNames, containerClassNames),
        title,
        onPress,
        align,
        icon: {
          name: "check_circle",
          color: colors.success.dark,
          size: 20,
          variant: "rounded",
        },
      },
      options,
    );
  };

  const warning = ({
    message,
    title,
    onPress,
    options,
    variant,
    headerClassNames,
    bodyClassNames,
    containerClassNames,
    align,
  }: AlertParams) => {
    return show(
      {
        message,
        ...setStyles(variant || "default", "warning", headerClassNames, bodyClassNames, containerClassNames),
        title,
        onPress,
        align,
        icon: {
          name: "warning",
          color: colors.warning.dark,
          size: 20,
          variant: "rounded",
        },
      },
      options,
    );
  };

  const danger = ({
    message,
    title,
    onPress,
    options,
    variant,
    headerClassNames,
    bodyClassNames,
    containerClassNames,
    align,
  }: AlertParams) => {
    return show(
      {
        message,
        ...setStyles(variant || "default", "danger", headerClassNames, bodyClassNames, containerClassNames),
        title,
        onPress,
        align,
        icon: {
          name: "error",
          color: colors.danger.dark,
          size: 20,
          variant: "rounded",
        },
      },
      options,
    );
  };

  const info = ({
    message,
    title,
    onPress,
    options,
    variant,
    headerClassNames,
    bodyClassNames,
    containerClassNames,
    align,
  }: AlertParams) => {
    return show(
      {
        message,
        ...setStyles(variant || "default", "info", headerClassNames, bodyClassNames, containerClassNames),
        title,
        onPress,
        align,
        icon: {
          name: "info",
          color: colors.info.dark,
          size: 20,
          variant: "rounded",
        },
      },
      options,
    );
  };

  const show = (props: AlertProps, options?: AlertOptions | null) => {
    options = options || {};
    Toast.show({
      ...defaultToastOptions,
      ...options,
      props,
    });
  };

  const defaultToastOptions: ToastShowParams = {
    autoHide: true,
    type: "basic",
    visibilityTime: 3000,
    onPress: () => Toast.hide(),
    topOffset: 60,
  };

  return {
    toastConfig,
    success,
    warning,
    danger,
    info,
  };
};
